<template>
  <FriedModal v-if="isVisible" class="unsupported-browswer-container">
    <template #header>
      <FriedModalHeader :header="$t('unsupported-browser')" />
    </template>
    <div>{{ $t('you-are-using-an-unsupported-browser') }}</div>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          id="close-button"
          data-external="unsupported-close-button"
          @click="handleClose"
        >
          {{ $t('close') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(_props, { emit }) {
    const handleClose = () => {
      emit('close');
    };
    return {
      handleClose,
    };
  },
});
</script>
